var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMaterialMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.463,
    height: 18.5,
    viewBox: "0 0 10.463 18.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-attach-money",
    "data-name": "Icon material-attach-money",
    d: "M15.112,12.619c-2.333-.606-3.083-1.233-3.083-2.21,0-1.12,1.038-1.9,2.775-1.9,1.829,0,2.508.874,2.569,2.158h2.271a4.1,4.1,0,0,0-3.3-3.916V4.5H13.262V6.72c-1.994.432-3.6,1.727-3.6,3.71,0,2.374,1.963,3.556,4.831,4.245,2.569.617,3.083,1.521,3.083,2.477,0,.709-.5,1.84-2.775,1.84-2.117,0-2.95-.946-3.063-2.158H9.48c.123,2.251,1.809,3.515,3.782,3.936V23h3.083V20.79c2-.38,3.6-1.542,3.6-3.649C19.943,14.223,17.445,13.226,15.112,12.619Z",
    transform: "translate(-9.48 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaterialMoney);
export default __webpack_public_path__ + "static/media/IconMaterialMoney.1e36b96477cd665d40d4d9bbd40441dd.svg";
export { ForwardRef as ReactComponent };